export default {"src":"/_next/static/media/rugby.638bae08.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};